import React from 'react';
import MaskedInput from 'react-text-mask';
import { getDateMask } from '../../utils/InputMaskUtils';

const DateMaskedInput = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      guide={true}
      keepCharPositions={true}
      mask={getDateMask()}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

export default DateMaskedInput;
